<div class="overlay" *ngIf="!embedded" (click)="toggleModal()"></div>
@if(isFirmwareUpdateModalOpen){
<app-firmware-update-modal (closeSignal)="onFirmwareUpdateClosed()" [metersIdsInput]="[device.id]"
  [targetMeterModels]="[devicePreviousModel]"></app-firmware-update-modal>
}@else if (showEditModal){
<app-device-edit [device]="device" [embedded]="embedded"
  (closeSignal)="onEditClosed()"></app-device-edit>
}@else if (!showEditModal && !showMeterGeoLocationHistoryModal) {
<div class="container flex-column m-0 p-0 d-flex" [class.embedded]="embedded">
  <div class="row g-0 m-0 p-4 justify-content-start borderb" *ngIf="!embedded">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title">{{ "METERDETAILS" | translate }}</span>
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
      <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"></svg-icon>
    </div>
  </div>
  <div class="row g-0 m-0 body">
    <div class="row g-0 m-0 pt-3">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_ASSETTYPE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          device.assetTypeName ? device.assetTypeName : "/"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_PARENT" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start align-items-center">
        <div class="parent-selected-display">
          <ng-container *ngIf="device.parent; else emptyParent">
            <div class="parent-item-row">
              <app-asset-type-badge [assetType]="device.parent.assetType"
                [label]="device.parent.assetTypeName"></app-asset-type-badge>
              <span class="parent-item-name">{{ device.parent.asset ?? "/" }}</span>
            </div>
            <span class="parent-item-meter mt-1">{{ device.parent.meterNumber ?? "/" }}</span>
          </ng-container>
          <ng-template #emptyParent>
            <span class="parent-item-name">/</span>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "SESSIONSTATUS" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start align-items-center">
        <span class="item-info status pt-1 pb-1 ps-2 pe-2" [ngClass]="{
            active: device.status === 'Online',
            inactive: device.status=== 'Offline',
          }">{{
          device.status ? device.status : "/"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_CONNECTION" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start align-items-center">
        <span class="item-info" [ngClass]="{
            active: device.connection === 'Connected',
            inactive: device.connection=== 'Disconnected',
          }">{{
          device.connection ? device.connection : "/"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_GSMIPSECCONNECTOR" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start align-items-center justify-content-between">
        <span class="item-info">{{
          device.ipSecConnector ? device.ipSecConnector : "/"
          }}</span>

        <label class="switch me-3">
          <input type="checkbox" [checked]="device.ipSecConnector != null"
            (change)="toggleIpSec($any($event.target).checked)" />
          <span class="slider round"></span>
        </label>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">
          {{
          "DEVICESETUP_ASSETLOCATION" | translate
          }}
        </span>
      </div>
      <div class="col-md-6 d-flex align-items-center">
        <span class="item-info width-12ch"
          [innerHTML]="formattedGeoLocation(device.serviceLatitude!, device.serviceLongitude!)">
        </span>
        @if(device.serviceLatitude != null && device.serviceLongitude != null){
        <div class="pe-4 d-flex justify-content-center align-items-center" (click)="showAssetMap()">
          <svg-icon alt="Geo location" role="button" src="assets/device/geo-location.svg"></svg-icon>
        </div>
        }
      </div>
    </div>

    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">
          {{ "DEVICESETUP_METERGEOLOCATION" | translate }}
        </span>
      </div>
      <div class="col-md-6 d-flex align-items-center">
        <span class="item-info width-12ch"
          [innerHTML]="formattedGeoLocation(firstGeoLocation?.latitude!, firstGeoLocation?.longitude!)">
        </span>
        <ng-container *ngIf="firstGeoLocation?.latitude != null && firstGeoLocation?.longitude != null">
          <div class="d-flex justify-content-center align-items-center"
            (click)="showMeterMap(firstGeoLocation?.latitude, firstGeoLocation?.longitude)">
            <svg-icon class="geo-location-icon" alt="Geo location" role="button" src="assets/device/geo-location.svg"></svg-icon>
          </div>
        </ng-container>
        <ng-container *ngIf="firstGeoLocation">
          <div class="d-flex justify-content-center align-items-center ps-2">
            <div class="col-md-3 p-2 d-flex justify-content-end ms-auto cursor-pointer" (click)="showGeoHistory()">
              <svg-icon class="geo-history-icon" alt="Geo location history" role="button" src="assets/device/hour.svg"></svg-icon>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_SERVICENAME" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ device.serviceName }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_REGION" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ device.regionName }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_AREA" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ device.areaName }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_DEVICEADDRESS" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ device.address }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_SERVICENUMBER" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          device.serviceNumber ? device.serviceNumber : "/"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_SERVICETYPE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          device.serviceTypeName ? device.serviceTypeName : "/"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_METERNO" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ device.meterNumber }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_METERMAKE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          device.meterMakeName
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">
          {{ "CURRENT" | translate }} {{ "DEVICESETUP_METERMODEL" | translate }}
        </span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">
          {{ device.meterModelName }} ({{ device.firmwareVersion }})<span *ngIf="device.currentVersion"> v{{ device.currentVersion }}</span>
        </span>
      </div>
    </div>

    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">
          {{ "NEXT" | translate }} {{ "DEVICESETUP_METERMODEL" | translate }}
        </span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">
{{ device.nextVersion ? (device.nextMeterModelName + ' (' + device.nextFirmwareVersion + ') v' + device.nextVersion) : '/' }}
        </span>
      </div>
    </div>

    @if (device.previousMeterModelName) {
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_PREVIOUSMETERMODEL" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ device.previousMeterModelName }}</span>

        @if (authService.isAuthorized([PermissionsEnum.Device_firmware_update])) {
        <span class="button-wrapper-gray m-3">
          <div class="button" [class.disabled]="!canRollbackFirmware" [title]="canRollbackFirmware
                  ? ('ROLLBACK' | translate)
                  : ('FIRMWARE_UPDATEDISABLED' | translate)"
            (click)="canRollbackFirmware && (isFirmwareUpdateModalOpen = true)">
            <img alt="Rollback" src="assets/device/firmware-update.svg" />
          </div>
        </span>
        }
      </div>
    </div>
    }

    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_METERTYPE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ device.meterType }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_METERPHASE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ meterModel.meterPhase }}</span>
      </div>
    </div>

    <div class="row g-0 m-0 pt-2">
      <div class="col-12 ps-4 pb-2">
        <span class="fw-semibold">{{ "DEVICESETUP_CT_RATIO" | translate }}</span>
      </div>
      <div class="col-md-6 ps-5 d-flex justify-content-start">
        <span class="item-name">{{ "DEVICESETUP_CT_NUMERATOR" | translate }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ device.currentTransformerRatio?.numerator ?? "/" }}</span>
      </div>
      <div class="col-md-6 ps-5 d-flex justify-content-start">
        <span class="item-name">{{ "DEVICESETUP_CT_DENOMINATOR" | translate }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ device.currentTransformerRatio?.denominator ?? "/" }}</span>
      </div>
    </div>

    <div class="row g-0 m-0 pt-2">
      <div class="col-12 ps-4 pt-2 pb-2">
        <span class="fw-semibold">{{ "DEVICESETUP_VT_RATIO" | translate }}</span>
      </div>
      <div class="col-md-6 ps-5 d-flex justify-content-start">
        <span class="item-name">{{ "DEVICESETUP_VT_NUMERATOR" | translate }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ device.voltageTransformerRatio?.numerator ?? "/" }}</span>
      </div>
      <div class="col-md-6 ps-5 d-flex justify-content-start">
        <span class="item-name">{{ "DEVICESETUP_VT_DENOMINATOR" | translate }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ device.voltageTransformerRatio?.denominator ?? "/" }}</span>
      </div>
    </div>

    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_FIRMWAREVERSION" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          device.firmwareVersion
          }}</span>
        <div class="position-relative d-inline-flex align-items-center">
          <svg-icon alt="Copy" class="copy-icon copyable" role="button" src="assets/core/copy-icon.svg"
            (click)="clipboardService.copyToClipboard(device.firmwareVersion!, $event)"></svg-icon>
          <span class="copy-tooltip" *ngIf="clipboardService.copiedText === device.firmwareVersion">{{"COPIED" |
            translate}}</span>
        </div>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_CELLULARSIMSN" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          device.cellularSimSerialNumber
          }}</span>
        <div class="position-relative d-inline-flex align-items-center">
          <svg-icon alt="Copy" class="copy-icon copyable" role="button" src="assets/core/copy-icon.svg"
            (click)="clipboardService.copyToClipboard(device.cellularSimSerialNumber!, $event)"></svg-icon>
          <span class="copy-tooltip" *ngIf="clipboardService.copiedText === device.cellularSimSerialNumber">{{"COPIED" |
            translate}}</span>
        </div>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_METERIP" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ device.meterIp }} </span>
        <div class="position-relative d-inline-flex align-items-center">
          <svg-icon alt="Copy" class="copy-icon copyable" role="button" src="assets/core/copy-icon.svg"
            (click)="clipboardService.copyToClipboard(device.meterIp!, $event)"></svg-icon>
          <span class="copy-tooltip" *ngIf="clipboardService.copiedText === device.meterIp">{{"COPIED" |
            translate}}</span>
        </div>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_METERPORT" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ device.meterPort }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_INTERFACE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ meterModel.interface }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_AUTHTYPE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          meterModel.authorizationLevel
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_DATACOLLECTIONINTERVALS" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{formatInterval(device.dataCollectionInterval)}}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{ "CLOCK_OFFSET" | translate }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          device.clockTolerance == null ? "No value" : device.clockTolerance
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_TIMEZONE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">GMT {{ device.meterTimeZone! / 60 }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_CLIENTADDRESS" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          meterModel.clientAddress
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_SECURITY" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{ meterModel.security }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_BLOCKCIPHERKEY" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          device.blockCipherKey ? device.blockCipherKey : "/"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICESETUP_AUTHENTICATIONKEY" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          device.authenticationKey ? device.authenticationKey : "/"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICES_METERINSTALLATIONDATE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          device.meterInstallationDate | date: "dd MMM yyyy"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICES_METERMANUFACTUREDATE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">
          {{
          device.meterManufactureDate ? (device.meterManufactureDate | date: "dd MMM yyyy") : "/"
          }}
        </span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICES_CREATIONDATE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          device.meterCreationDate | date: "dd MMM yyyy, h:mm a"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICES_EDITDATE" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          device.lastUpdateTime | date: "dd MMM yyyy, h:mm a"
          }}</span>
      </div>
    </div>
    <div class="row g-0 m-0 pb-3">
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-name">{{
          "DEVICES_SMSWAKETIME" | translate
          }}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-start">
        <span class="item-info">{{
          device.lastSmsWakeTime ? (device.lastSmsWakeTime | date: "dd MMM yyyy, h:mm a") : "/"
          }}</span>
      </div>
    </div>
  </div>
  <div class="row g-0 m-0 p-3 align-items-end bordert">
    <div class="col-md-9 pt-2 pb-2 ps-2 d-flex justify-content-start" *ngIf="!embedded" (click)="toggleModal()">
      <span role="button" class="item-name">{{
        "CLOSE_WINDOW" | translate
        }}</span>
    </div>
    @if (authService.isAuthorized([PermissionsEnum.Device_modify])) {
    <div class="col-md-3 p-2 d-flex justify-content-end edit rounded ms-auto cursor-pointer" (click)="edit()">
      <span class="item-name pe-2">{{ "EDIT_DEVICE" | translate }}</span>
      <img alt="Edit" src="assets/device/edit.svg" />
    </div>
    }
  </div>
</div>
}@else{
<div class="container flex-column m-0 p-0 d-flex">
  <div class="row g-0 m-0 p-0 justify-content-end">
    <div class="col d-flex justify-content-start align-items-center popup-title ps-3 pt-3 pb-3">
      <span>{{"DEVICESETUP_SHOWGEOHISTORY" | translate}}</span>
    </div>
    <div class="col d-flex justify-content-end align-items-center pe-3">
      <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"
        (click)="showMeterGeoLocationHistoryModal=false"></svg-icon>
    </div>
  </div>
  <div class="row d-flex g-0 m-0 justify-content-center flex-grow-1">
    <div class="col-12 p-0 m-0 overflow-y-auto geodata">
      <ul class="m-0 p-4">
        <li class="list-group-item m-0 p-0" *ngFor="let loc of geoLocationHistory">
          <div class="d-flex start g-0 m-0 p-2">
            <!-- Location Pin -->
            <div class="location-pin d-flex flex-column align-items-center justify-content-center me-2 cursor-pointer">
              <svg-icon alt="location mark" src="assets/device/location-mark.svg"
                (click)="showMeterMap(loc.latitude, loc.longitude)"></svg-icon>
              <svg-icon alt="location mark line" src="assets/device/location-line.svg"></svg-icon>
            </div>

            <!-- Coordinates -->
            <div class="d-flex flex-row">
              <span class="pe-1">{{ "LATITUDE" | translate }}<br>{{ "LONGITUDE" | translate }}</span>
              <span class="pe-3">{{ loc.latitude }}<br>{{ loc.longitude }}</span>
            </div>

            <!-- Address -->
            <div class="flex-grow-1 me-3">
              {{ loc.address }}
            </div>

            <!-- Date aligned to right -->
            <div class="text-end geo-date">
              {{ loc.locationTime | date: "dd MMM yy HH:mm" }}
            </div>

          </div>
        </li>

      </ul>
    </div>
  </div>
</div>
}

<div *ngIf="isMapVisible && !showEditModal">
  <div class="overlay-light" (click)="closeMap()"></div>

  <div class="map flex-column m-0 p-0 d-flex">
    <!-- Header -->
    <div class="row g-0 m-0 p-0 justify-content-end">
      <div class="col d-flex justify-content-start align-items-center popup-title ps-3 pt-3 pb-3">
        <span>
          {{ mapType === 'asset' ? ('ASSET_COORDINATES' | translate) : ('METER_COORDINATES' | translate) }}
        </span>
      </div>
      <div class="col d-flex justify-content-end align-items-center pe-3">
        <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg" (click)="closeMap()"></svg-icon>
      </div>
    </div>

    <!-- Map Body -->
    <div class="row d-flex g-0 m-0 justify-content-center flex-grow-1" *ngIf="mapCenter">
      <google-map height="100%" width="100%" [zoom]="14" [center]="mapCenter" [options]="{
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true
      }">
        <map-marker [position]="mapCenter"></map-marker>
      </google-map>
    </div>
  </div>
</div>
